"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Shows buttons for register and login
 * @param {ButtonsProps} props
 * @returns {JSX.Element}
 */
const Buttons = ({
  registerLink,
  signInLink
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.BUTTONS),
    children: [registerLink?.relativeUrl && registerLink.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      "data-testid": getTestId(_constants.REGISTER_BUTTON),
      href: registerLink.relativeUrl,
      variant: "contained",
      color: "primary",
      children: registerLink.title
    }) : null, signInLink?.relativeUrl && signInLink.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      "data-testid": getTestId(_constants.LOGIN_BUTTON),
      variant: "outlined",
      color: "default",
      onClick: _presentationUtils.doLogin,
      children: signInLink.title
    }) : null]
  });
};
exports.Buttons = Buttons;
